import Vue from 'vue';
export const EventBus = new Vue({
  data: {
    mobile: null,
    storeLinkObject: null
  },
});